__turbopack_context__.v({
  "ctaWrap": "link-module-scss-module__Rrlbrq__ctaWrap",
  "tertiary": "link-module-scss-module__Rrlbrq__tertiary",
});
